import React from 'react';

const S = {
  title: {
    fontFamily: "'Bangers', cursive",
    fontSize: '26px', letterSpacing: '1.5px',
    color: '#3D1F0A', textTransform: 'uppercase',
    marginBottom: '6px', textAlign: 'center',
  },
  sub: {
    fontFamily: "'Nunito', sans-serif",
    fontSize: '13px', color: '#6B4A1A',
    marginBottom: '20px', textAlign: 'center',
  },
  input: {
    width: '100%', padding: '14px 16px',
    background: '#FFF9EE',
    border: '3px solid #3D1F0A',
    borderRadius: '12px',
    color: '#3D1F0A', fontSize: '15px',
    fontFamily: "'Nunito', sans-serif", fontWeight: '700',
    marginBottom: '8px', outline: 'none',
    boxSizing: 'border-box',
    boxShadow: 'inset 0 2px 5px rgba(61,31,10,0.08)',
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  err: {
    fontFamily: "'Nunito', sans-serif",
    fontSize: '12px', color: '#B33000',
    marginBottom: '12px', fontWeight: '800',
  },
};

export default function StepX({ form, handleChange, next }) {
  const isValid = form.x.startsWith('@') && form.x.length > 1;
  return (
    <div>
      <h2 style={S.title}>Enter Your X Handle</h2>
      <p style={S.sub}>Your X (Twitter) username to get started</p>

      <input
        className="wl-input"
        name="x"
        placeholder="@yourhandle"
        value={form.x}
        onChange={(e) => {
          let v = e.target.value;
          if (v && !v.startsWith('@')) v = '@' + v;
          handleChange({ target: { name: 'x', value: v } });
        }}
        style={S.input}
      />

      {!isValid && form.x && (
        <p style={S.err}>⚠ Username must start with @ (e.g. @username)</p>
      )}

      <button
        className="wl-btn-primary"
        onClick={next}
        disabled={!isValid}
        style={{
          width: '100%', padding: '16px', marginTop: '10px',
          background: isValid
            ? 'linear-gradient(160deg, #C87400 0%, #A85E00 100%)'
            : 'rgba(61,31,10,0.2)',
          border: '3px solid #3D1F0A',
          borderRadius: '12px',
          color: isValid ? '#F5EDD6' : '#8B6914',
          fontSize: '18px', fontWeight: '900',
          fontFamily: "'Bangers', cursive", letterSpacing: '2px',
          textTransform: 'uppercase',
          cursor: isValid ? 'pointer' : 'not-allowed',
          transform: isValid ? 'skewX(-4deg)' : 'none',
          boxShadow: isValid ? '0 6px 0 #7A4A00' : 'none',
          transition: 'all 0.12s ease',
          opacity: isValid ? 1 : 0.55,
        }}
      >
        <span style={{ display: 'inline-block', transform: isValid ? 'skewX(4deg)' : 'none' }}>
          {isValid ? 'CONTINUE →' : 'ENTER VALID HANDLE'}
        </span>
      </button>
    </div>
  );
}
